module.exports = __webpack_public_path__ + "static/media/logo.796a89cd.png";